import { render, staticRenderFns } from "./MlwUserAgreement.vue?vue&type=template&id=2224f0ce&scoped=true"
import script from "./MlwUserAgreement.vue?vue&type=script&lang=js"
export * from "./MlwUserAgreement.vue?vue&type=script&lang=js"
import style0 from "./MlwUserAgreement.vue?vue&type=style&index=0&id=2224f0ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2224f0ce",
  null
  
)

export default component.exports